import React from 'react'
import Trns from 'src/localization/Trns'
import { RecurrenceModel } from 'src/models/recurrence.models'
import { convertUTCRecurringLabel, extendWeekdays } from 'src/utils/date.utils'

interface RecurrenceFrequencyLabelProps {
  className?: string
  recurrence: RecurrenceModel
  timezone: string
}

const RecurrenceFrequencyLabel: React.FC<RecurrenceFrequencyLabelProps> = (
  props,
): React.ReactElement => {
  if (props.recurrence.byWeekDay !== undefined) {
    return props.recurrence.interval === 1 ? (
      <Trns
        source={'Every Week, on ${byWeekDay}'}
        expressions={{
          byWeekDay: extendWeekdays(props.recurrence.byWeekDay),
        }}
      />
    ) : (
      <Trns
        source={'Every ${interval} Weeks, on ${byWeekDay}'}
        expressions={{
          interval: `${props.recurrence.interval}`,
          byWeekDay: extendWeekdays(props.recurrence.byWeekDay),
        }}
      />
    )
  } else if (props.recurrence.byMonthDay !== undefined) {
    return props.recurrence.interval === 1 ? (
      <Trns
        source={'Every Month, on the ${byMonthDay}'}
        expressions={{
          byMonthDay: convertUTCRecurringLabel(
            `${props.recurrence.byMonthDay}-01-3000`,
            'DD-MM-YYYY',
            props.timezone,
          ).format('Do'),
        }}
      />
    ) : (
      <Trns
        source={'Every ${interval} Months, on the ${byMonthDay}'}
        expressions={{
          interval: `${props.recurrence.interval}`,
          byMonthDay: convertUTCRecurringLabel(
            `${props.recurrence.byMonthDay}-01-3000`,
            'DD-MM-YYYY',
            props.timezone,
          ).format('Do'),
        }}
      />
    )
  } else if (props.recurrence.byYearDay !== undefined) {
    return (
      <Trns
        source={'Every Year, on ${byYearDay}'}
        expressions={{
          byYearDay: convertUTCRecurringLabel(
            `${props.recurrence.byYearDay} 3000`,
            'DDD YYYY',
            props.timezone,
          ).format('MMMM D'),
        }}
      />
    )
  } else {
    return props.recurrence.interval === 1 ? (
      <Trns source={'Every Day'} />
    ) : (
      <Trns
        source={'Every ${interval} Days'}
        expressions={{
          interval: `${props.recurrence.interval}`,
        }}
      />
    )
  }
}

export default RecurrenceFrequencyLabel
